module.exports = __webpack_public_path__ + "img/893.247a2755.png";